import React, { forwardRef } from 'react';

export const Switch = forwardRef(
  ({ placeholder, label, error, id, extraClasses, ...rest }, ref) => {
    const text = error || label || '';
    return (
      <div className="d--flex flex--column">
        {text && (
          <label
            className={`label--control font--sm font--500 m-b--xs  ${
              error ? 'text--secondary' : 'text--black'
            }`}
          >
            {text}
          </label>
        )}
        <span className={`custom-checkbox d--flex ${extraClasses}`}>
          <input
            ref={ref}
            {...rest}
            id={id}
            type="checkbox"
            placeholder={placeholder}
            checked={rest?.value}
          />
          <label htmlFor={id}>{label}</label>
        </span>
      </div>
    );
  },
);
